import { jSith } from "../jquery-replacement";
import { isUndefined } from "./index";

export namespace S25String {
    export function camelToOther(str: string, delim: string): string {
        return str
            .replace(/[\w]([A-Z])/g, function (m) {
                return m[0] + delim + m[1];
            })
            .toLowerCase();
    }

    export function otherToCamel(str: string, delim: string): string {
        const pat = "(" + delim + "\\w)";
        const reg = new RegExp(pat, "g");
        return str.replace(reg, function (m) {
            return m[1].toUpperCase();
        });
    }

    export function toTitleCase(str: string): string {
        return firstCharToUpper(otherToCamel(str, " "));
    }

    export function camelToSnake(str: string): string {
        return camelToOther(str, "_");
    }

    export function snakeToCamel(str: string): string {
        return otherToCamel(str, "_");
    }
    export function nestedStr(val: any): string {
        return (jSith.coalesce(val, "") + "").replace(/'/g, "\\'").replace(/"/g, '\\"');
    }

    export function escapeRegExp(str?: string) {
        return (str || "").replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"); //$& means whole matched string
    }

    export function replaceAll(str: string, find: string, replace: string) {
        return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
    }
    export function addSlash(str: string): string {
        if (str.substring(str.length - 1) !== "/") {
            str += "/";
        }
        return str;
    }

    //dynamic programming implementation of min edit dist (substit is same cost as insert/delete)
    export function minEditDist(s1: string, s2: string): number {
        s1 = s1 || "";
        s2 = s2 || "";
        const tbl: number[][] = [[]]; //2d array of form [s1.len + 1][s2.len + 1] = 0
        const s2Arr = []; //helper array to get [s2.len + 1] = 0
        let i = 0;
        for (i = 0; i <= s2.length; i++) {
            s2Arr.push(0);
        }
        for (i = 0; i <= s1.length; i++) {
            //initiate tbl to [s1.len + 1][s2.len + 1] = 0
            tbl.push([...s2Arr]);
        }

        for (i = 0; i <= s1.length; i++) {
            for (let j = 0; j <= s2.length; j++) {
                if (i === 0) {
                    tbl[i][j] = j; //if i is 0, then we must insert the rest of j (s2) so the cost is j to go from 0/empty string to j
                } else if (j === 0) {
                    //if j is 0, similarly, to go from 0/empty string to i is i
                    tbl[i][j] = i;
                } else if (s1[i - 1] === s2[j - 1]) {
                    tbl[i][j] = tbl[i - 1][j - 1];
                } else {
                    tbl[i][j] =
                        1 +
                        Math.min(
                            //each op has cost of 1 and we want the min of remaining choices
                            tbl[i - 1][j], //deletion of char in s1 to get closer to s2
                            tbl[i][j - 1], //insertion of char into s1 to get closer to s2
                            tbl[i - 1][j - 1], //replacement of char in s1 with char in s2 to get closer to s2
                        );
                }
            }
        }
        return tbl[s1.length][s2.length];
    }
    export function leftPad(val: any, desiredLen: number, padWith?: any): string {
        val = jSith.toStr(val);
        padWith = padWith || "0";
        return val.length >= desiredLen ? val : new Array(desiredLen - val.length + 1).join(padWith) + val;
    }
    export function isValidEmail(emailString: string): boolean {
        //ported from BB file modals.xml, used to validate contact email
        return (
            !!emailString &&
            /^[A-Z0-9\~\!\`\|\$\%\*\/\=\?\^\{\}\#\&\'\.\_\+\-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailString)
        );
    }

    export function isInvalidEmail(email: string): boolean {
        return !isValidEmail(email);
    }
    export function split(str: string, delim: string): string[] {
        return str.split(delim);
    }
    export function contains(str: string | undefined, term: string): boolean {
        return !!str && str.indexOf(term) !== -1;
    }

    export function endsWith(str: string | undefined, term: string): boolean {
        return !!str && str.indexOf(term, str.length - term.length) !== -1;
    }

    export function trim(str: string): string {
        return typeof str === "string" ? str.trim() : str;
    }
    export function firstCharToLower(str?: string) {
        if (!str) return "";
        return str[0].toLowerCase() + str.slice(1);
    }

    export function firstCharToUpper(str?: string) {
        if (!str) return "";
        return str[0].toUpperCase() + str.slice(1);
    }

    export function capitalizeWords(str: string) {
        return str.split(/\s+/).map(firstCharToUpper).join(" ");
    }

    export function pluralize(word: string, count: number): string {
        if (isUndefined(word)) return "";
        if (isUndefined(count)) return "s";
        return `${word}${count !== 1 ? "s" : ""}`;
    }
}
